import { useMutation } from "@apollo/client/react";
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { VALIDATE_RI } from "../../../data/graphQL/mutations/ResumenIngresoValidation/ValidateRI";
import { CAMBIO_FLUJO_A_RI } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CambioFlujoARI';

export const useGetActions = ({ notification,
  moduloHE,
  moduloSI,
  moduloCP,
  moduloSSAE,
  moduloCD,
  hasEsquemaBAP,
  tipoNotificacion
}) => {
  const navigate = useNavigate();

  const [validarRI, { loading: validateLoading }] = useMutation(VALIDATE_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: (evaluacionData) => {
      toast.success("Se ejecutó la validación correctamente!");
    }
  });

  const [sendNotificacion, { loading: notificarLoading }] = useMutation(CAMBIO_FLUJO_A_RI, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      toast.success('La notificación inició el flujo correctamente!');
    }
  });

  const handleClickValidar = (rechazo, requiereIndicacion, countIndicaciones) => {
    if (moduloHE && !!rechazo?.observacion ||
      moduloSI && !requiereIndicacion ||
      moduloCP || moduloSSAE || moduloCD ||
      !!countIndicaciones && countIndicaciones !== 0 ||
      hasEsquemaBAP) {
      validarRI({
        variables: {
          input: {
            idEvaluacion: notification?.idEvaluacion,
            idMotivoRechazo: rechazo?.idMotivoRechazo,
            observacion: rechazo?.observacion || '',
            tipoNotificacion,
            requiereIndicacion: requiereIndicacion
          }
        }
      }).
        then((res) => {
          setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
        }).
        catch(() => toast.error('Ha ocurrido un error!'));;
    } else {
      if (moduloHE && !rechazo?.observacion)
        toast.error('No se puede validar la solicitud sin observación.'); else

        toast.error('No se puede validar la solicitud sin tener indicaciones.');
    }
  };

  const handleClickNotificar = () => {

    sendNotificacion({
      variables: {
        input: {
          idEvaluacion: notification.idEvaluacion,
          tipoNotificacionAsistencial: tipoNotificacion
        }
      }
    }).then((res) => {
      setTimeout(() => navigate('/asignacionValidacionResumenIngreso'), 1000);
    }).catch(() => toast.error('Ha ocurrido un error!'));
  };

  return {
    handleClickValidar,
    handleClickNotificar,
    loading: validateLoading || notificarLoading
  };
};